export default __webpack_public_path__ + "static/media/logo_Cadence.1a9271b2.svg";